import 'flatpickr/dist/themes/material_green.css';
import Flatpickr from 'react-flatpickr';
import "flatpickr/dist/l10n/cs.js";
import "./CustomCalendar.css";
import React, { useState, useEffect, useCallback } from 'react';
import { activeDays } from "../common/ApiUtils";
import { formatDate } from "../common/TimeUtils";
import { useNavigate } from "react-router-dom";

const CustomCalendar = ({ date: initialDate }) => {
  const [date, setDate] = useState(initialDate);
  const [daysWithRows, setDaysWithRows] = useState([]);
  const [daysWithRowsSet, setDaysWithRowsSet] = useState(new Set());
  const navigate = useNavigate();

  useEffect(() => {
    setDate(initialDate);
  }, [initialDate]);

  // Convert array to Set for faster lookups and update when daysWithRows changes
  useEffect(() => {
    setDaysWithRowsSet(new Set(daysWithRows));
  }, [daysWithRows]);

  const fetchActiveDays = async (month, year) => {
    try {
      const response = await activeDays({ year, month });
      let daysWithData = response.enabled ? [...response.enabled] : [];

      const today = new Date();
      if (month === today.getMonth() + 1 && year === today.getFullYear()) {
        var todayFormated = today.getDate() + "." +(today.getMonth() +1)+ "." + today.getFullYear();
        // Only add today if it's not already in the list
        if (!daysWithData.includes(todayFormated)) {
          daysWithData.push(todayFormated);
        }
      }

      // Normalize all dates to same format (d.m.Y without leading zeros) for consistency
      // API returns dates in format "dd.MM.yyyy" (with leading zeros), convert to "d.m.Y" (without leading zeros)
      const normalizedDates = daysWithData.map(dateStr => {
        // Handle different possible formats
        const parts = dateStr.split('.');
        if (parts.length === 3) {
          // Remove leading zeros by parsing to int and converting back
          const day = parseInt(parts[0], 10);
          const month = parseInt(parts[1], 10);
          const year = parseInt(parts[2], 10);
          return `${day}.${month}.${year}`;
        }
        return dateStr;
      });

      console.log("Fetched days with rows (normalized):", normalizedDates);
      console.log("Original dates from API:", daysWithData);
      setDaysWithRows(normalizedDates);
    } catch (error) {
      console.error("Failed to fetch active days:", error);
      setDaysWithRows([]);
    }
  };

  const onReady = (selectedDates, dateStr, instance) => {
    // Fetch active days when calendar is ready
    if (instance) {
      fetchActiveDays(instance.currentMonth + 1, instance.currentYear);
    }
  };

  const onSelectDate = (selectedDates, dateStr, instance) => {
    if (instance) {
      fetchActiveDays(instance.currentMonth + 1, instance.currentYear);
    }
  };

  // Memoize onDayCreate to have access to current daysWithRowsSet
  const onDayCreate = useCallback((dObj, dStr, fp, dayElem) => {
    if (!dayElem || !dayElem.dateObj) return;
    
    // Format date to match the normalized format (d.m.Y - no leading zeros)
    const day = dayElem.dateObj.getDate();
    const month = dayElem.dateObj.getMonth() + 1;
    const year = dayElem.dateObj.getFullYear();
    const dayDate = `${day}.${month}.${year}`;
    
    // Check if this date has existing rows using the Set
    if (daysWithRowsSet.has(dayDate)) {
      // Add custom class to mark dates with existing rows
      dayElem.classList.add('has-rows');
    }
  }, [daysWithRowsSet]);

  const onDateChange = (selectedDates) => {
    if (selectedDates.length > 0) {
      navigate(`/flyday/${formatDate(selectedDates[0])}`);
    }
  };

  // 1. Získání pole povolených dat v požadovaném Flatpickr formátu
  // (zatím nepoužito; dříve se přes `enable` omezoval výběr)

  return (
      <Flatpickr
          value={date}
          options={{
            dateFormat: "d.m.Y",
            // Remove enable restriction - allow all dates to be selected
            locale: "cs",
            //enable: enabledDates,
            onDayCreate: onDayCreate,
            disableMobile: true
          }}
          onReady={onReady}
          onOpen={onSelectDate}
          onMonthChange={onSelectDate}
          onYearChange={onSelectDate}
          onChange={onDateChange}
      />
  );
};

export default CustomCalendar;
